import axios from "axios";

export const editorjs_config = {
    /**
     * Id of Element that should contain the Editor
     */
    placeholder: 'Let`s write an awesome story!',

    holder: 'editorjs',
    /**
     * Available Tools list.
     * Pass Tool's class or Settings object for each Tool you want to use
     */
    tools: {
        header: Header,
        list: List,
        image: {
            class: ImageTool,
            config: {
                endpoints: {
                    byFile: localStorage.getItem("api_address")+'api/admin/html_uploader', // Your backend file uploader endpoint
                    byUrl: 'http://localhost:8008/fetchUrl', // Your endpoint that provides uploading by Url
                }
            }
        },
        productTool: {
            class: LinkTool,
            config: {
                endpointList: localStorage.getItem("api_address")+'api/admin/product/editor-url-search', // Your backend endpoint for url data fetching,
                endpointUrl: localStorage.getItem("api_address")+'api/admin/product/editor-url-product', // Your backend endpoint for url data fetching,
            }
        },
        productToolAnchor: {
            class: ProductToolAnchor,
            config: {
                endpointList: localStorage.getItem("api_address")+'api/admin/product/editor-url-search', // Your backend endpoint for url data fetching,
                endpointUrl: localStorage.getItem("api_address")+'api/admin/product/editor-url-product', // Your backend endpoint for url data fetching,
            }
        },
        productGrid: {
            class: ProductGrid,
            config: {
                apiCatEndpoint: localStorage.getItem("api_address")+'api/admin/product/editor_product_grid', // Your backend endpoint for url data fetching,
                apiTagEndpoint: localStorage.getItem("api_address")+'api/admin/product/editor_product_grid', // Your backend endpoint for url data fetching,
            }
        },
        table: Table,
        raw: RawTool,
        style: EditorJSStyle.StyleInlineTool,
        paragraph: {
            class: Paragraph,
            inlineToolbar: true,
            config:{
                defaultAlignment: 'right',
            }
        },
        toggle: {
            class: ToggleBlock,
            inlineToolbar: true,
        },
        breakLine: {
            class: BreakLine,
            inlineToolbar: true,
            shortcut: 'CMD+SHIFT+ENTER',
        },
        embed: Embed,

    }
}


export const parser_config = {
    image: {
        use: "figure",
        // use figure or img tag for images (figcaption will be used for caption of figure)
        // if you use figure, caption will be visible
        imgClass: "img", // used class for img tags
        figureClass: "fig-img", // used class for figure tags
        figCapClass: "fig-cap", // used class for figcaption tags
        path: "absolute",
        // if absolute is passed, the url property which is the absolute path to the image will be used
        // otherwise pass a relative path with the filename property in <> like so: '/img/<fileName>'
    },
    paragraph: {
        pClass: "paragraph", // used class for paragraph tags
    },
    code: {
        codeBlockClass: "code-block", // used class for code blocks
    },
    embed: {
        useProvidedLength: false,
        // set to true if you want the returned width and height of editorjs to be applied
        // NOTE: sometimes source site overrides the lengths so it does not work 100%
    },
    quote: {
        applyAlignment: false,
        // if set to true blockquote element will have text-align css property set
    },
};
export const parser_config_in_site = {
    image: {
        use: "figure",
        // use figure or img tag for images (figcaption will be used for caption of figure)
        // if you use figure, caption will be visible
        imgClass: "img", // used class for img tags
        figureClass: "fig-img", // used class for figure tags
        figCapClass: "fig-cap", // used class for figcaption tags
        path: "absolute",
        // if absolute is passed, the url property which is the absolute path to the image will be used
        // otherwise pass a relative path with the filename property in <> like so: '/img/<fileName>'
    },
    paragraph: {
        pClass: "paragraph", // used class for paragraph tags
    },
    code: {
        codeBlockClass: "code-block", // used class for code blocks
    },
    embed: {
        useProvidedLength: false,
        // set to true if you want the returned width and height of editorjs to be applied
        // NOTE: sometimes source site overrides the lengths so it does not work 100%
    },
    quote: {
        applyAlignment: false,
        // if set to true blockquote element will have text-align css property set
    },
};
// console.log("parse data", "html parser")
export const custom_parser_config_in_site = {
    productTool: function (data, config) {
        // parsing functionality

        return `
<div class="product_card border rounded p-2 shadow " >
<a class="product_card_root"  href="${data.link}" >

    <div class=" w-[100px] h-[100px] product_card_image" style="background-image: url(${data.meta.image.url});"></div>
    <div>
        <div class="font-bold ms-10">${data.meta.title}</div>
        <div class="product_card_button_price" >
            <p class="link-tool__description" style="margin: 5px">
(data.meta.productPrice)
             تومان
             </p>
            <div style="margin: 5px"  class="btn-primary px-6  nuxt-link-active" >
            مشاهده و خرید
            </div>

        </div>
    </div>

</a>
</div>
`;

        // the config arg is user provided config merged with default config
    },
    productToolAnchor: function (data, config) {
        // parsing functionality

        return `
<div class="product_card border rounded p-2 shadow " >
<a class="product_card_root"  href="${data.link}" >

    <div class=" w-[100px] h-[100px] product_card_image" style="background-image: url(${data.meta.image.url});"></div>
    <div>
        <div class="font-bold ms-10">${data.meta.title}</div>
        <div class="product_card_button_price" >
        
            <div style="margin: 5px"  class="btn-primary px-6  nuxt-link-active" >
            مشاهده و خرید
            </div>

        </div>
    </div>

</a>
</div>
`;

        // the config arg is user provided config merged with default config
    },
    image: function (data, config) {
        return `<img src="${data.file.url}" alt="${data.caption}" >`;
    }
}
